import { useMutation } from '@tanstack/react-query';
import {
  IPostMyOwnTractorImagesParams,
  postMyOwnTractorImages,
} from '../../../../api/user/mutations/postMyOwnTractorImages';

export const usePostMyOwnTractorImages = () => {
  return useMutation(postMyOwnTractorImages);
};
